import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { SummaryBlock } from '@core/services/ai/ai-assistant.service';

@Component({
  selector: 'app-ai-summary-block',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <div class="block" [attr.data-tone]="block.tone || 'info'">
      <header class="block__header">
        <mat-icon class="block__icon">{{
          block.icon || defaultIcon()
        }}</mat-icon>
        <span class="block__title">{{ block.title }}</span>
      </header>
      <ul class="block__bullets">
        @for (b of block.bullets; track b) {
          <li>{{ b }}</li>
        }
      </ul>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .block {
        background: #fff;
        border: 1px solid rgba(15, 23, 42, 0.08);
        border-left: 3px solid #6366f1;
        border-radius: 12px;
        padding: 12px 14px;
      }
      .block[data-tone='success'] {
        border-left-color: #10b981;
      }
      .block[data-tone='warning'] {
        border-left-color: #f59e0b;
      }
      .block__header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
      }
      .block__icon {
        font-size: 20px;
        width: 20px;
        height: 20px;
        color: #6366f1;
      }
      .block[data-tone='success'] .block__icon {
        color: #10b981;
      }
      .block[data-tone='warning'] .block__icon {
        color: #f59e0b;
      }
      .block__title {
        font-weight: 600;
        font-size: 14px;
        color: rgba(15, 23, 42, 0.92);
      }
      .block__bullets {
        margin: 0;
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 14px;
        line-height: 1.45;
        color: rgba(15, 23, 42, 0.85);

        li {
          overflow-wrap: anywhere;
          word-break: break-word;
        }
      }
    `
  ]
})
export class AiSummaryBlockComponent {
  @Input({ required: true }) block!: SummaryBlock;

  defaultIcon(): string {
    switch (this.block.tone) {
      case 'success':
        return 'check_circle';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  }
}
